export const productTypeValues = [
  'prebidStack',
  'priceGenius',
  'refresher',
  'unfilledRecovery',
  'viewabilityTools',
  'richPlacements',
] as const

export type Product = (typeof productTypeValues)[number]
